<template>
<div class="wrap">    
    <schoolAndDate :schoolName="schoolName" :dateTime="dateTime" />
    <div class="container">
        <div class="list-data scorll-ant" ref="content" :style="`animation-duration:${animationDuration}s`">
            <div class="list-wrap" v-for="(listItem, listIdx) in dataList" :key="listIdx">
                <div class="list-header">
                    <span class="list-time">{{ renderDate(listItem.updateTime) }}</span>
                    <span class="list-num">{{ renderImgs(listItem.content).num }}份</span>
                </div>
                <div class="list-content">
                    <div class="list-title">
                        <span class="list-type"
                            :class="{ 'type1': (listItem.status == '0'), 'type2': (listItem.status == '1') }">
                            {{ ['食材检测', '餐具检测'][listItem.status] }}
                        </span>
                        <span class="list-name">{{ listItem.title || '' }}</span>
                    </div>
                    <div class="list-imgs">
                        <div class="img-wrap" v-html="renderImgs(listItem.content).html"></div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import schoolAndDate from "./schoolAndDate.vue";
export default {
    props: {
        schoolName: {
            type: String,
            default: '',
        },
        dateTime: {
            type: String,
            default: '',
        },
        deptId: {
            type: String,
            default: ''
        },
    },
    data() {
        return {
            dataList: [],
            animationDuration: 0,
        }
    },
    components: { schoolAndDate, },
    computed: {},
    mounted() {
        this.initListData()
    },
    methods: {
        initListData() {
            this.$get(this.$api.getTestingPublicity, {
                current: 1,
                size: -1,
                deptId: this.deptId,
            }).then(res => {
                console.log('检测公示列表数据-res', res)
                const { code, success, data } = res
                if (code == 200 && success) {
                    this.dataList = data.records
                }
            })
            setTimeout(() => {
                this.$nextTick(() => {
                    this.calcDocumentHeight()
                })
            }, 6000)
        },

        renderDate(dateStr) {
            try {
                const [yyyy, DD, mm] = dateStr.split(' ')[0].split("-")
                return `${yyyy}年${DD}月${mm}日`
            } catch (error) {
                return dateStr
            }
        },

        renderImgs(content = '') {
            try {
                const imgArr = content.match(/<img.*?>/g)
                const imgNum = imgArr.length || 0
                return {
                    html: imgArr.join(''),
                    num: imgNum,
                }
            } catch (error) {
                return { html: '', num: 0 }
            }
        },

        // 计算高度
        calcDocumentHeight() {
            if (this.$refs.content.offsetHeight > 900) {
                this.animationDuration = (this.$refs.content.offsetHeight / 200) * 4.0 // 2.5
            }
        }
    },
}
</script>
<style lang="scss" scoped>
@keyframes scroll-up {
    0% {
        transform: translateY(vh(100));
        /* 文本初始位置，向上偏移 0 */
    }

    100% {
        transform: translateY(-100%);
        /* 文本最终位置，向上偏移 100%（等于滚动区域高度） */
    }
}

.wrap {
    position: relative;
}
.container {
    overflow: hidden;
    height: vh(766);
    width: 100%;

    .list-data {
        padding: vh(60) vh(20);
        background: linear-gradient(to bottom, #1E57BA, #1964E6);

        .list-wrap {
            margin-bottom: 20px;
            border-bottom: 1px solid rgba($color: #00F6FF, $alpha: 0.3);

            &:last-of-type {
                border-bottom: none;
            }
        }

        .list-header {
            display: flex;
            justify-content: space-between;
            font-size: vh(20);

            .list-time {
                color: #fff;
            }

            .list-num {
                color: #00F6FF;
            }
        }

        .list-content {
            font-size: vh(22);
            text-align: left;
            margin: vh(20) 0 vh(10);

            .list-title {
                white-space: break-spaces;

                .list-type {
                    color: #001FBC;
                    display: inline-block;
                    padding: vh(2) vh(10);
                    font-size: vh(16);
                    border-radius: vh(20);
                    margin-right: vh(10);

                    &.type1 {
                        background: linear-gradient(to bottom, #84F5DE, #4CE2F8);
                    }

                    &.type2 {
                        background: linear-gradient(to bottom, #FFBB2A, #FFE49A);
                    }
                }

                .list-name {
                    vertical-align: middle;
                    color: #fff;
                }
            }

            .list-imgs {
                white-space: break-spaces;
                margin: vh(10) 0 vh(10);

                .img-wrap> ::v-deep img {
                    display: inline-block;
                    width: 50%;
                    height: vh(364);
                    padding-bottom: vh(10);
                    font-size: 0;

                    &:nth-child(even) {
                        padding-left: vh(5);
                    }

                    &:nth-child(odd) {
                        padding-right: vh(5);
                    }
                }
            }
        }
    }
}



.scorll-ant {
    display: flex;
    flex-direction: column;
    min-height: 100%;
    width: 100%;
    animation-name: scroll-up;
    animation-duration: 0;
    animation-timing-function: linear;
    animation-iteration-count: infinite;
}
</style>